import { render, staticRenderFns } from "./TwoColumns.vue?vue&type=template&id=af834542&"
import script from "./TwoColumns.vue?vue&type=script&lang=js&"
export * from "./TwoColumns.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports